import type { HTMLAttributes } from 'react';
import { cx } from '../utils/cx.js';
import styles from './StatusDot.module.css';

export type StatusDotTone = 'success' | 'muted' | 'danger' | 'warning' | 'neutral';

export type StatusDotProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: StatusDotTone;
  size?: number;
};

export function StatusDot({ tone = 'neutral', size = 10, className, style, ...rest }: StatusDotProps) {
  return (
    <span
      className={cx(styles.dot, styles[`tone_${tone}`], className)}
      style={{ width: size, height: size, ...style }}
      {...rest}
    />
  );
}
